export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assigné à"])},
        "assign_to_me": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["M'assigner"])},
        "unassigned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non assigné"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assigned to"])},
        "assign_to_me": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Assign to me"])},
        "unassigned": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unassigned"])}
      }
    }
  })
}
